// export const clientId = '6cb621bc-15d4-4fda-94eb-9f648f4d4803'
// export const authority = 'https://login.microsoftonline.com/8a1ef6c3-8324-4103-bf4a-1328c5dc3653'
// export const redirectUri = 'http://localhost:3000/'
// export const scopes = ["api://menu-hub-api-dev/.default"]
// export const baseURL = "https://api-dev.grupomarista.org.br/public/saude/menu-hub/v1"

export const clientId = process.env.REACT_APP_CLIENT_ID || ""
export const authority = process.env.REACT_APP_AUTHORITY || ""
export const redirectUri = process.env.REACT_APP_REDIRECT_URI || ""
export const scopes = [process.env.REACT_APP_SCOPES || ""]
export const baseURL = process.env.REACT_APP_BASE_URL_BACKEND || ""
export const logAcessoBaseURL = process.env.REACT_APP_LOG_ACESSO_BASE_URL || ""
export const logAcessoNomeSolucao = process.env.REACT_APP_LOG_ACESSO_NOME_SOLUCAO || ""